import { z } from 'zod';

import { BasePType } from './base';

export const EmailOptIn = BasePType.extend({
  type: z.enum(['emailOptIn']),
});

export type EmailOptIn = z.infer<typeof EmailOptIn>;
